
<mat-form-field  class="full-width">
  <mat-label>{{libelle}}</mat-label>
    <input 
      type="text"
      matInput
      (change)="$event.target.value === '' ? deleteIfEmptyOrNotFound(): null"
      [required]="required"
      [placeholder]="'Sélectionner une valeur'"
      [formControl]="myControl"      
      [matAutocomplete]="auto">
  <mat-autocomplete 
    #auto="matAutocomplete"
    panelWidth="auto"
    (optionSelected)="onObjetChange($event.option.value)">
    
    <mat-option *ngFor="let obj of filteredObjets | async" [value]="obj"> 
      {{obj}}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="myControl.hasError('forbiddenNames')">
    Veuillez sélectionner une valeur suggérée
  </mat-error>
  <mat-error *ngIf="myControl.hasError('required')">
    Ce champ est obligatoire
  </mat-error>
</mat-form-field>
